import React from "react";
import CircularProgress, {
  circularProgressClasses,
} from "@mui/material/CircularProgress";
import useSize from "@hooks/common/useSize";

const PageLoader = ({ panelLoader, classType, type }) => {
  const winDimensions = useSize();

  return (
    <div
      className={`bs-loader ${
        panelLoader ? panelLoader : classType ? classType : type ? type : ""
      }`}
    >
      <CircularProgress
        variant="indeterminate"
        disableShrink
        sx={{
          color: (theme) =>
            theme.palette.mode === "light"
              ? "var(--primary)"
              : "var(--primary)",
          animationDuration: "2000",
          [`& .${circularProgressClasses.circle}`]: {
            strokeLinecap: "round",
          },
        }}
        size={50}
        thickness={5}
      />
    </div>
  );
};

export default PageLoader;
